import * as z from 'zod';

import { withPasswordRequirements } from '@/modules/common/validations/password-requirements';

export const accountActivationFormSchema = z
  .object({
    email: z.string().nonempty(),
    password: withPasswordRequirements(z.string().trim().nonempty()),
    confirmPassword: z.string().trim(),
  })
  .refine(data => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'unauthenticated.accountActivation:error.passwordsDoNotMatch',
  });
